<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <!-- <DefaultLayout /> -->
  <!-- <router-view></router-view> -->
  <router-view
    v-slot="{ Component }"
    :key="route.fullPath"
  >
    <keep-alive :include="['EquipmentAdd']">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import DefaultLayout from './components/layout/DefaultLayout.vue'
// import HomePage from './page/HomePage.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
    // DefaultLayout
    // HomePage
  }
}
</script>

<script setup>
import { useRoute } from 'vue-router'
const route = useRoute()
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* margin-top: 60px; */
  min-width: 1912px;
  height: 100%;
}
</style>
